import { Validators } from '@angular/forms';
import { INPUT_TYPES_CONFIG } from '../products.config';

export const CONTENTS = {
  nickname: 'PRODUCTS.CONTENTS.shortname',
  properties: [
    {
      name: 'calculatedClientAge', key: 'CLIENT_AGE', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.TEL,
      validator: ['', [
        Validators.pattern(/^\d+$/)
      ]]
    },
    {
      name: 'deductible', key: 'DEDUCTIBLE', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE_HOUSE.4', value: '4000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE_HOUSE.6', value: '6000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE_HOUSE.8', value: '8000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE_HOUSE.12', value: '12000' }
        ]
      }
    },
    { name: 'objectAddress', key: 'OBJECT_ADDRESS', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.STRING,
      validator: ['', [
        Validators.required
      ]]
    },
    { name: 'objectZipCode', key: 'OBJECT_ZIP_CODE', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.TEL,
      validator: ['', [
        Validators.required,
        Validators.pattern('[0-9]{4}$')
      ]]
    },
    {
      name: 'productPackage', key: 'PRODUCT_PACKAGE', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.STANDARD', value: 'STANDARD' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.SUPER', value: 'SUPER' }
        ]
      }
    },
    {
      name: 'productSumInsured', key: 'SUM_INSURED', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.NUMBER,
      validator: ['', [
        Validators.required
      ]]
    },
    { name: 'houseIsRented', key: 'HOUSE_IS_RENTED', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_OWNER_PRIMARY.NOT_RENTED', value: 'NO' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_OWNER_PRIMARY.PARTIALLY_RENTED', value: 'PARTIAL' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_OWNER_PRIMARY.RENTED', value: 'YES' }
        ]
      },
      validator: ['', [
        Validators.required
      ]]
    },

    {
      name: 'houseSMBurglarAlarmConnected', key: 'HOUSE_SM_BURGAR_ALARM_CONNECTED', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          {
            key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_SM_BURGAR_ALARM_CONNECTED.LOCAL_NOTIFICATION',
            value: 'LOCAL_NOTIFICATION'
          },
          {
            key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_SM_BURGAR_ALARM_CONNECTED.SECURITY_COMPANY_NOTIFICATION',
            value: 'SECURITY_COMPANY_NOTIFICATION'
          },
          {
            key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_SM_BURGAR_ALARM_CONNECTED.FIRE_ALARM_SECURITY_COMPANY_NOTIFICATION',
            value: 'FIRE_ALARM_SECURITY_COMPANY_NOTIFICATION'
          },
          {
            key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_SM_BURGAR_ALARM_CONNECTED.FIRE_ALARM_LOCAL_NOTIFICATION',
            value: 'FIRE_ALARM_LOCAL_NOTIFICATION'
          },
          {
            key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_SM_BURGAR_ALARM_CONNECTED.NO',
            value: 'NO'
          }
        ]
      }
    },
    {
      name: 'houseSMFireAlarmConnected', key: 'HOUSE_SM_FIRE_ALARM_CONNECTED_TTFINANS', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          {
            key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_SM_FIRE_ALARM_CONNECTED.INTERCONNECTED_SMOKE_DETECTORS',
            value: 'INTERCONNECTED_SMOKE_DETECTORS'
          },
          {
            key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_SM_FIRE_ALARM_CONNECTED.NO',
            value: 'NO'
          }
        ]
      }
    },
    {
      name: 'houseSMAutomaticWaterStop', key: 'HOUSE_SM_AUTOMATIC_WATER_STOP', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          {
            key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_SM_AUTOMATIC_WATER_STOP.WITHOUT_NOTIFICATION',
            value: 'WITHOUT_NOTIFICATION'
          },
          {
            key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_SM_AUTOMATIC_WATER_STOP.WITH_NOTIFICATION',
            value: 'WITH_NOTIFICATION'
          },
          {
            key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_SM_AUTOMATIC_WATER_STOP.NO',
            value: 'NO'
          }
        ]
      }
    },
    {
      name: 'houseBuildingHasPower', key: 'HOUSE_BUILDING_HAS_POWER_CONTENTS', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          {
            key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_HAS_POWER.NEWER_THAN_15_YEARS',
            value: 'NEWER_THAN_15_YEARS'
          },
          {
            key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_HAS_POWER.OLDER_THAN_15_YEARS',
            value: 'OLDER_THAN_15_YEARS'
          }
        ]
      }
    },
    {
      name: 'houseNumberOfResidents', key: 'HOUSE_NUMBER_OF_RESIDENTS', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_NUMBER_OF_RESIDENTS.1', value: '1' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_NUMBER_OF_RESIDENTS.2', value: '2' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_NUMBER_OF_RESIDENTS.3', value: '3' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_NUMBER_OF_RESIDENTS.4', value: '4' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_NUMBER_OF_RESIDENTS.5', value: '5' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_NUMBER_OF_RESIDENTS.6', value: '6' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_NUMBER_OF_RESIDENTS.7', value: '7' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_NUMBER_OF_RESIDENTS.8_OR_MORE', value: '8_OR_MORE' },
        ]
      }
    },
    {
      name: 'contentsType', key: 'CONTENTS_TYPE', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          {
            key: 'PROPERTIES_FORM.SELECT_LIST.CONTENTS_TYPE.PRIVATE_CONTENTS_AND_MOVABLES',
            value: 'PRIVATE_CONTENTS_AND_MOVABLES'
          },
          {
            key: 'PROPERTIES_FORM.SELECT_LIST.CONTENTS_TYPE.BUSINESS_CONTENTS_AND_MOVABLES',
            value: 'BUSINESS_CONTENTS_AND_MOVABLES'
          },
          {
            key: 'PROPERTIES_FORM.SELECT_LIST.CONTENTS_TYPE.GARAGE_OUTBUILDING_CONTENTS',
            value: 'GARAGE_OUTBUILDING_CONTENTS'
          },
          {
            key: 'PROPERTIES_FORM.SELECT_LIST.CONTENTS_TYPE.OWN_FITTINGS',
            value: 'OWN_FITTINGS'
          },
          {
            key: 'PROPERTIES_FORM.SELECT_LIST.CONTENTS_TYPE.STORED_CONTENTS',
            value: 'STORED_CONTENTS'
          },
          {
            key: 'PROPERTIES_FORM.SELECT_LIST.CONTENTS_TYPE.FARM_MOVABLES_AND_DISCONTINUED_FARM',
            value: 'FARM_MOVABLES_AND_DISCONTINUED_FARM'
          },
        ]
      }
    },
    {
      name: 'houseBuildingType', key: 'BUILDING_TYPE', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.INNBO_HOUSE', value: 'INNBO_HOUSE' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.INNBO_CABIN', value: 'INNBO_CABIN' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.INNBO_APARTMENT', value: 'INNBO_APARTMENT' },
        ]
      }
    },
    {
      name: 'addElectricBicycleCoverage', key: 'ADD_ELECTRIC_BICYCLE_COVERAGE', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      isElectricBicycleCoverageCheck: true,
      validator: ['', [
        Validators.required
      ]]
    },
    {
      name: 'electricBicycleValue', key: 'ELECTRIC_BICYCLE_VALUE', group: 'INSURANCE_INFO',
    },
    {
      name: 'electricBicycleCoveragePackage', key: 'ELECTRIC_BICYCLE_COVERAGE_PACKAGE', group: 'INSURANCE_INFO',
    },
    { name: 'houseRotAndAnimalDamage', key: 'HOUSE_ROT_AND_ANIMAL_DAMAGE', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
  ],
  icon:'contents'
};
